// ─── Dashboards Index Route ───
// /app/dashboards (exact) — resolves the active dashboard and redirects to
// /app/dashboards/$dashboardId per docs/design/components/dashboard-engine.md
// §1.1's resolution order. Renders inside the `dashboards.tsx` layout's
// <Outlet/>. See ADR 0021 (Phase 12 Batch 2).

import { createFileRoute } from '@tanstack/react-router';
import { DashboardsIndexPage } from '../../features/dashboards/DashboardsIndexPage';

export const Route = createFileRoute('/app/dashboards/')({
  component: DashboardsIndexPage,
});
